import React from "react";

import { trimText } from "../../../lib/helpers/trimText";
import { DeviceTreeDevice } from "./lib/deviceTree";

import "../../shared/Forms/WayFinderForm/shared/WayFinderFormWorkspaces/WayFinderFormWorkspaces.scss";

interface Props {
  devices: DeviceTreeDevice[];
  onRemove: (device: DeviceTreeDevice) => void;
}

export const SelectedDevices = ({ devices, onRemove }: Props) => (
  <div className="WayFinderFormWorkspaces SelectedDevices">
    <label className="label__main mt-3">
      Selected devices ({devices.length})
    </label>

    <div className="WayFinderFormWorkspaces__list d-flex flex-wrap">
      {devices.map((device) => (
        <span
          key={device.id}
          title={device.name}
          className="WayFinderFormWorkspacesItem mb-1"
        >
          {trimText(device.name, 20)}
          <button
            type="button"
            aria-label={`Remove ${device.name}`}
            className="SelectedDevices__remove"
            onClick={() => onRemove(device)}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  </div>
);
